import { createSelector } from "reselect";
import { getProductPrice } from "../../utils/getProductPrice";
const createCartItemsSelector = createSelector.withTypes();
export const selectProductFreeGiftsInCart = createCartItemsSelector([
    (state) => state.cart.items,
    (state) => state.cart.currency,
    (state) => state.freeTrialCart.items,
    (state) => state.freeTrialCart.currency,
    (state, giftParentId) => giftParentId,
    (state, giftParentId, isFreeTrial) => isFreeTrial,
], (standardCartProducts, standardCartCurrency, freeTrialCartProducts, freeTrialCartCurrency, giftParentId, isFreeTrial) => {
    const productsInCart = isFreeTrial ? freeTrialCartProducts : standardCartProducts;
    const currency = isFreeTrial ? freeTrialCartCurrency : standardCartCurrency;
    if (!Array.isArray(productsInCart) || !giftParentId) {
        return [];
    }
    return productsInCart
        .filter((product) => product.isGift && product.parentGiftId === giftParentId)
        .map((product) => (Object.assign(Object.assign({}, product), { price: getProductPrice(product, currency) })));
});
//# sourceMappingURL=selectProductFreeGiftsInCart.js.map